var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#E13838"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_326_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4211 30.5609L14.2997 28.4395C14.102 28.2434 13.9474 28.0081 13.8459 27.7488C13.7443 27.4895 13.6981 27.2118 13.71 26.9336C13.722 26.6553 13.792 26.3826 13.9155 26.133C14.0389 25.8833 14.2132 25.6622 14.427 25.4838C16.8393 23.5444 19.6729 22.1978 22.7002 21.5523C25.4943 20.9295 28.3913 20.9295 31.1854 21.5523C34.2252 22.202 37.0691 23.5586 39.4869 25.5121C39.7001 25.69 39.8739 25.9103 39.9973 26.159C40.1207 26.4078 40.191 26.6795 40.2036 26.9568C40.2162 27.2342 40.171 27.5112 40.0707 27.7701C39.9705 28.029 39.8174 28.2642 39.6212 28.4608L37.4999 30.5821C37.1601 30.9286 36.7059 31.1398 36.222 31.1762C35.738 31.2126 35.2573 31.0718 34.8695 30.7801C34.1011 30.1907 33.2685 29.6902 32.3875 29.2881C32.0393 29.1301 31.7437 28.8756 31.5356 28.5548C31.3276 28.234 31.2159 27.8602 31.2137 27.4779V25.6818C28.4368 24.9182 25.5053 24.9182 22.7284 25.6818V27.4779C22.7263 27.8602 22.6146 28.234 22.4066 28.5548C22.1985 28.8756 21.9029 29.1301 21.5547 29.2881C20.6737 29.6902 19.8411 30.1907 19.0727 30.7801C18.6808 31.0751 18.194 31.2158 17.7051 31.1754C17.2162 31.1349 16.7592 30.9163 16.4211 30.5609Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_326_2228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(43.9414 26.9688) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.2f9568ce17563f1a04c08e897b6a5677.svg";
export { ForwardRef as ReactComponent };